import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component:() => {return import('@/views/home.vue')}
  },
  {
    path: '/recivingPage',
    name: 'quickPayReceiving',
    component:() => {return import('@/views/quick-pay/index.vue')}
  },
  {
    path: '/quick-pay',
    name: 'quickPay',
    component:() => {return import('@/views/quick-pay/index.vue')}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to,form,next) => {
    next()
})
export default router
